import { Component, Input, ViewEncapsulation, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Mote, MoteState, MoteType, MoteTypeIconMap } from '../../models';
import { MoteEvent, MoteEventType } from '../../models';
import { AutoSubOnDestroy, AutoSub } from '../../providers/auto-sub';
import { Animations } from '../../animations';

@AutoSubOnDestroy()
@Component({
    selector: 'mini-mote',
    templateUrl: 'mini-mote.component.html',
    styleUrls: ['mini-mote.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [Animations.fadeIn()]
})
export class MiniMoteComponent {
    public mote: Mote = null;

    @Input() set moteInput(mote: Mote) { this.updateMote(mote) };
    // TODO: Implement this
    @Input() loadDelay: number = 0;
    @Input() hideActionButton: boolean = false;
    @Input() hideTitleIcon: boolean = false;
    @Input() hideTitle: boolean = false;
    @Input() hideLock: boolean = false;
    @Input() actionButtonText: string = '';
    @Input() specialIcon: string = '';
    @Input() showPreviewText: boolean = true;

    @Input() set showDetails(show: boolean) { this.doShowDetails = show };
    @Input() set showSelector(show: boolean) { this.doShowSelector = show };
    @Input() isSelected: boolean;

    @Output() moteEvent = new EventEmitter<MoteEvent>();
    @Output() iconClick = new EventEmitter<void>();

    public imageLoaded: boolean = false;

    public hasUserVote: boolean = false;
    // Export enum for the view
    public MoteState = MoteState;
    public MoteType = MoteType;
    public MoteTypeIconMap = MoteTypeIconMap;

    public doShowDetails = true;
    public doShowSelector = false;

    constructor(private cd: ChangeDetectorRef) {
    }

    private updateMote(mote: Mote) {
        // Save mote in component
        this.mote = mote;

        // Update length and duration if it is not set beforehand
        // if(this.mote.type == MoteType.ROUTE) {
        //     if(!this.mote.length) this.mote.updateLength();
        //     if(!this.mote.duration) this.mote.updateDuration();
        // };
        // if(this.mote.type == MoteType.COLLECTION && this.mote.childCount == -1){
        //     this.mote.childCount = 0; // Reset child count
        //     let children:Mote[] = [];

        //     // Find all child Motes in cache
        //     for(let key in Mote.moteCache){ 
        //         if(Mote.moteCache[key].parent == this.mote.key) {
        //             this.mote.childCount++;
        //             children.push(Mote.moteCache[key]);
        //         }
        //     }
        //     children.sort((a,b)=>a.distance-b.distance); // Sort based on distance (realistic scenario for unlcoking Motes in collection)
        //     let geometryCoords = [] // Coords to calculate total length of collection 
        //     children.forEach(c =>geometryCoords.push(c.geometry.coordinates)); // Push all children for distance 
        //     if(this.mote.length == 0) this.mote.updateLength(geometryCoords);
        //     if(this.mote.duration == 0) this.mote.updateDuration();
        // }

        // Show changes in view
        this.cd.markForCheck();

        if(!mote) return;
        // Subscribe for changes of this mote
        AutoSub(this).reg['moteUpdate'] = this.mote.watchUpdates().subscribe(mote => {
            this.cd.markForCheck();
        });
    }

    private emitEvent(type: MoteEventType, options = null) {
        this.moteEvent.emit({ mote: this.mote, type: type, options: options });
    }

    public buttonClick() {
        // This is a link to a inactive route
        if(this.mote.moteState == MoteState.INACTIVE) {
            // this.emitEvent(MoteEventType.INACTIVE_SELECTED);
            this.emitEvent(MoteEventType.START_TOUR);
        }
        else if(this.mote.moteState == MoteState.AVAILABLE) {
            // this.emitEvent(MoteEventType.SHOW_MOTE_ON_MAP, {preventZoom:false, minZoom: 15});
            this.emitEvent(MoteEventType.UNLOCK_MOTE);
        }
        else if(this.mote.moteState == MoteState.UNLOCKED || this.mote.moteState == MoteState.USERMOTE) {
            this.emitEvent(MoteEventType.OPEN_UNLOCKED_MOTE);
        }
    }

    public iconClicked() {
        this.iconClick.emit();
    }
}
